import { RocketPart, RocketPartConfig } from "./RocketPart";

export class GameState {
    public partConfig: RocketPartConfig;
    public index: number;
    public shipTexture: string;

    /**
     * Dynamic reference to current gamestate!
     */
    public static current: GameState;

    constructor() {
        this.index = 0;
        this.partConfig = RocketPart.ROCKET_PARTS[this.index];
        this.shipTexture = "assembly" + (this.index + 1);
    }

    /**
     * Updates the game state by adding to the index and setting the next part
     * Also returns boolean whether or not the game is over
     */
    public static getNextPart(): boolean {
        GameState.current.index = GameState.current.index + 1;
        GameState.current.shipTexture = "assembly" + (GameState.current.index + 1);

        if (GameState.current.index === RocketPart.ROCKET_PARTS.length) {
            // Game Is Over!
            return true;
        }
        else {
            GameState.current.partConfig = RocketPart.ROCKET_PARTS[GameState.current.index];
            return false;
        }
    }
}



// WEBPACK FOOTER //
// ./src/games/RocketRepairGame/objects/GameState.ts